import { parse } from "@fortawesome/fontawesome-svg-core";
import { format } from "date-fns";
import { Time } from "highcharts";
import moment from "moment";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
//import * as XLSX2 from '';

function getTodayDate() {
  var today = new Date();
  return today;
}

function getZulluTimeFormatExtra(time) {
  var offSet = moment.utc(time).local().format().slice(0, 16);
  // if (time.length === 16) {
  //   console.log(time + offSet, "sdcded");
  //   return time + offSet;
  // }
  // if (time && time.length > 21) {
  //   return time.replace(" ", "T").slice(0, time.length - 7);
  // }
  return offSet;
}

function getPreviousDate(date, interval) {
  const toDate = new Date(date);
  const fromDate = new Date(toDate);
  fromDate.setDate(fromDate.getDate() - interval);
  return fromDate;
}
function getNextDate(date, interval) {
  const toDate = new Date(date);
  const fromDate = new Date(toDate);
  fromDate.setDate(fromDate.getDate() + interval);
  return fromDate;
}
function monthOfYearAsString(monthIndex) {
  return [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ][monthIndex];
}
function dayOfWeekAsString(dayIndex) {
  return ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"][dayIndex];
}
function dateFormatForPopOver(startTime, endTime) {
  var sTime = new Date(startTime);
  var eTime = new Date(endTime);
  var format = `${dayOfWeekAsString(
    sTime.getDay(),
  )}, ${sTime.getDate()} ${monthOfYearAsString(
    sTime.getMonth(),
  )} - ${dayOfWeekAsString(
    eTime.getDay(),
  )}, ${eTime.getDate()} ${monthOfYearAsString(eTime.getMonth())}`;
  return format;
}
function getInitials(name) {
  let removeExtraSpaces = /\s{2,}/g;
  var words = name?.replace(removeExtraSpaces, " ").trim().split(" ");
  var initials = "";
  words?.forEach((word) => {
    initials += word[0].toUpperCase();
  });

  return initials;
}
function getDateInFormat(date) {
  var dateToChange = new Date(date);
  var month = dateToChange.getMonth();
  var date_ = dateToChange.getDate();
  var year = dateToChange.getFullYear();
  return `${month + 1} / ${date_} / ${year}`;
}

function getDateIn_DD_MM_YYYY_Format(date) {
  var dateToChange = new Date(date);
  var month = dateToChange.getMonth();
  var date_ = dateToChange.getDate();
  var year = dateToChange.getFullYear();
  return `${date_} / ${month + 1} / ${year}`;
}
function deleteAlertDialog(yesFunc, params) {
  return window.confirm("Are you sure you want to delete?") && yesFunc(params);
}
function convertBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}
function getDateInputFormat(date) {
  var date__ = new Date(date);
  var year = date__.getFullYear();
  var month =
    date__.getMonth() + 1 >= 10
      ? date__.getMonth() + 1
      : `0${date__.getMonth() + 1}`;
  var datee =
    date__.getDate() >= 10 ? date__.getDate() : `0${date__.getDate()}`;
  return `${month}-${datee}-${year}`;
}

export function getDateDDMMYYYY(date) {
  var date__ = new Date(date);
  var year = date__.getFullYear();
  var month =
    date__.getMonth() + 1 >= 10
      ? date__.getMonth() + 1
      : `0${date__.getMonth() + 1}`;
  var datee =
    date__.getDate() >= 10 ? date__.getDate() : `0${date__.getDate()}`;
  return `${datee}/${month}/${year}`;
}

function getInitialName(name) {
  let initials;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
    initials =
      nameSplit[0].substring(0, 1) + nameSplit[nameLength - 1].substring(0, 1);
  } else if (nameLength === 1) {
    initials = nameSplit[0].substring(0, 1);
  } else return;

  return initials.toUpperCase();
}
function createImageFromInitials(size, name, color) {
  if (name == null) return;
  name = getInitialName(name);

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = canvas.height = size;

  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, size, size);

  context.fillStyle = `${color}50`;
  context.fillRect(0, 0, size, size);

  context.fillStyle = color;
  context.textBaseline = "middle";
  context.textAlign = "center";
  context.font = `${size / 2}px Roboto`;
  context.fillText(name, size / 2, size / 2);

  return canvas.toDataURL();
}
function getRandomColor() {
  var letters = "0123456789ABCDEF";
  var color = "#";
  // for (var i = 0; i < 6; i++) {
  //   color += letters[Math.floor(Math.random() * 16)];
  // }
  return color;
}
function getDifferenceInDays(start, end) {
  let nStart = new Date(start).getTime();
  let nEnd = new Date(end).getTime();

  let differenceInMilliseconds = nEnd - nStart;
  let differenceInDays = differenceInMilliseconds / (1000 * 3600 * 24);

  return differenceInDays;
}
function convertExcelToJSON(filename, saveExpneseList) {
  if (filename) {
    // var fileReader = new FileReader();
    // fileReader.readAsBinaryString(filename);
    // fileReader.onload = function (event) {
    //     var data = event.target.result;
    //     var workbook = XLSX.read(data, { type: "binary" });
    //     console.log('workbook ::', workbook);
    //     workbook.SheetNames.forEach(sheet => {
    //         //let rowObj = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
    //         let rowObj = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
    //         let jsonObj = JSON.stringify(rowObj);
    //         console.log("File in JSON::", rowObj);
    //         setterFunc(rowObj);
    //     })
    // }
    const reader = new FileReader();
    reader.readAsBinaryString(filename);

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws);
      //setterFunc(data);
      //console.log("JSON data in file::", data);
      if (saveExpneseList) {
        saveExpneseList(data);
      }
      //console.log("File in JSON::", data);
      /* Update state */
      //   this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
      //     console.log(JSON.stringify(this.state.data, null, 2));
      //   });
    };

    // if (rABS) {
    //   reader.readAsBinaryString(this.state.file);
    // } else {
    //   reader.readAsArrayBuffer(this.state.file);
    // };
  }
}
function convert1000ToK(value) {
  if (value > 999 && value < 1000000) {
    return (value / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
  } else if (value < 1000) {
    return value; // if value < 1000, nothing to do
  }
}
function getCountryTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function dateFormat(startTime) {
  var sTime = new Date(startTime);
  var format = `${dayOfWeekAsString(
    sTime.getDay(),
  )}, ${sTime.getDate()} ${monthOfYearAsString(
    sTime.getMonth(),
  )} ${sTime.getFullYear()}`;
  return format;
}
function HourMinuteFormat(str) {
  var res = str.split(":");
  return parseInt(res[0]) + 5 + ":" + res[1];
}
function getHours(str) {
  var res = str.split(":");
  return parseInt(res[0]);
}
function getTimeInHoursMinutes(timeStr) {
  // console.log("here:::", timeStr)
  if (!timeStr) return [0, 0];
  let temp = `03-03-2021 ${timeStr}`;
  let sTime = new Date(temp);
  const hr = sTime.getHours();
  const min = sTime.getMinutes();
  return [hr, min];
}
function getDifferenceInTime(start, end) {
  var diff = new Date(start).getTime() + new Date(end).getTime();
  var diff_as_date = new Date(diff);
  return `${diff_as_date.getHours()} H, ${diff_as_date.getMinutes()} M`;
}

function TimeNow() {
  var d = new Date();
  var n = d.toTimeString();
  return n;
}

function GMTTime(timeStr) {
  if (!timeStr) return [0, 0];
  let temp = `2010-10-10 ${timeStr}`;
  let t = new Time(temp);
  var d = new Date();
  var n = d.getTimezoneOffset();
  var newTime = n / -60 + t;
  return newTime;
}

function getLocalTimeFromUTCTime(timeStr) {
  if (!timeStr) return "Not Found";
  let temp = `2010-10-10T${timeStr.split(".")[0]}Z`;
  // console.log('temp', temp);
  // console.log('get new date', new Date());
  var newDate = new Date(temp);
  // console.log('tostring', newDate.toString());
  // console.log('UTCtostring', newDate.toUTCString());
  // console.log('toLocaleTimeString', newDate.toLocaleTimeString());
  return newDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  //let t = new Time(temp);
  // var d = new Date();
  // var n = d.getTimezoneOffset();
  // console.log('timezoneoffset', n);
  // var newTime = (n / -60) + t;
  // console.log('new time string', newTime);
  // return newTime;
}
function getLocalTimeFromUTCTimeWithoutSeconds(timeStr) {
  if (!timeStr) return "Not Found";
  let temp = `2010-10-10T${timeStr.split(".")[0]}Z`;
  // console.log('temp', temp);
  // console.log('get new date', new Date());
  var newDate = new Date(temp);
  // console.log('tostring', newDate.toString());
  // console.log('UTCtostring', newDate.toUTCString());
  // console.log('toLocaleTimeString', newDate.toLocaleTimeString());
  return newDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  //let t = new Time(temp);
  // var d = new Date();
  // var n = d.getTimezoneOffset();
  // console.log('timezoneoffset', n);
  // var newTime = (n / -60) + t;
  // console.log('new time string', newTime);
  // return newTime;
}

function getDifferenceInMinutes(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60);
}

function dateCheck(startDate, endDate) {
  var GivenDate = startDate;
  var CurrentDate = new Date(endDate);
  GivenDate = new Date(GivenDate);
  if (GivenDate > CurrentDate) {
    return true;
  } else {
    return false;
  }
}
function convertTZ(date, tzString) {
  if (date) {
    return new Date(
      (typeof date === "string" ? new Date(date) : date).toLocaleString(
        "en-US",
        { timeZone: tzString },
      ),
    );
  }
}

function removeHtmlTag(string) {
  if (string) {
    return string.replace(/<[^>]*>?/gm, "");
  }
}

function getDaysInMonth(month, year) {
  var date = new Date(year, month, 1);
  var days = [];
  while (date.getMonth() === month) {
    days.push(date.getDate());
    date.setDate(date.getDate() + 1);
  }
  return days;
}

function getRandomValueByRange(min, max) {
  return parseInt(Math.random() * (max - min) + min);
}

const getPreviewDays = (days) => {
  let date = new Date();
  let last = new Date(date.getTime() - days * 24 * 60 * 60 * 1000);
  let day = last.getDate();
  let month = last.getMonth();
  return `${day} ${monthOfYearAsString(month)}`;
};

function getRandomArray(arr, n) {
  var result = new Array(n),
    len = arr.length,
    taken = new Array(len);
  if (n > len)
    throw new RangeError("getRandom: more elements taken than available");
  while (n--) {
    var x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}

function GetCalculatePercentage(todayCompletedTasks, todayTotalTasks) {
  let percentage = (todayCompletedTasks / todayTotalTasks) * 100;
  return percentage;
}
function GetRoundoffValue(completedproject, totalProject) {
  let roundoff = Math.round((completedproject / totalProject) * 100);
  return roundoff;
}

function EstimatedTimeToIntConvertor(estimatedTime) {
  var num = estimatedTime.match(/\d+/g);
  var totalTime = 0;
  totalTime += parseInt(num[0]) * 10080;
  totalTime += parseInt(num[1]) * 1440;
  totalTime += parseInt(num[2]) * 60;
  totalTime += parseInt(num[3]);
  return totalTime;
}

function IntToEstimatedTimeConvertor(totalTime) {
  var timeString = "";
  let week = parseInt(totalTime / 10080);
  totalTime -= week * 10080;
  let day = parseInt(totalTime / 1440);
  totalTime -= day * 1440;
  let hour = parseInt(totalTime / 60);
  totalTime -= hour * 60;
  let minute = parseInt(totalTime);
  timeString = week + "w " + day + "d " + hour + "h " + minute + "m";
  return timeString;
}

function GetLocalTimeSpan(timeSpan) {
  if (timeSpan) {
    var date = new Date();
    const offset = date.getTimezoneOffset();
    var receivedTime = timeSpan.split(":");
    var mins =
      parseInt(receivedTime[0]) * 60 +
      parseInt(receivedTime[1]) +
      parseFloat(offset);
    var calcHours = 0;
    if (mins > 60) {
      while (mins % 60 > 0) {
        calcHours += 1;
        mins -= 60;
      }
    }
    return calcHours + ":" + mins + ":" + receivedTime[2];
  } else {
    return "--:--:--";
  }
}

function IntegerToTimeString(integerValue) {
  // Here, integerValue is in minutes.
  const h = Math.floor(integerValue / 60);
  const m = integerValue % 60;

  // Format hours and minutes with leading zeros
  const formattedH = h < 10 ? "0" + h : h;
  const formattedM = m < 10 ? "0" + m : m;

  return `${formattedH}:${formattedM}`;
}

function TimeStringToInteger(duration) {
  if (duration) {
    var d = duration.split(":");
    return parseInt(d[0]) * 60 * 60 + parseInt(d[1]) * 60 + parseInt(d[2]);
  }
}
function TimeStringToIntegerMins(duration) {
  if (duration) {
    var d = duration.split(":");
    var hours = parseInt(d[0], 10);

    var minutes = parseInt(d[1], 10);

    // Convert hours to minutes and add the minutes

    return hours * 60 + minutes;
  }
  return 0;
}
function GetTaskTimeProgress(totalTimeSpent, currentEstimatedTime) {
  if (totalTimeSpent == null) return 0;
  var progress = totalTimeSpent / currentEstimatedTime;
  return progress < 1 ? progress * 100 : 100;
}

function GetProjectTaskProgress(completedTask, totalTask) {
  if (completedTask == null || totalTask == null || completedTask === 0)
    return 0;
  var progress = completedTask / totalTask;
  return progress < 1 ? progress * 100 : 100;
}

function GetDaysBetweenDates(startDate, endDate) {
  const diffInMs = new Date(endDate) - new Date(startDate);
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  return diffInDays;
}

function getOverdueDays(endDate) {
  if (!endDate) return;
  let result =
    Math.abs(
      Math.floor((new Date(endDate) - Date.now()) / (1000 * 60 * 60 * 24)),
    ) - 1;
  result = result > 1 ? `${result} Days` : `${result} Day`;
  return result;
}

function getElementIndex(element) {
  return Array.from(element.parentNode.children).indexOf(element);
}

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

const capitalizeFirstLetterOfEachWord = (data) => {
  let breakString = data.split(" ");
  let capitiliazeString = "";
  for (let i = 0; i < breakString.length; i++) {
    let capitiliazeFirstLetter =
      breakString[i].charAt(0).toUpperCase() + breakString[i].slice(1);
    if (i !== 0) {
      capitiliazeString += " ";
    }
    capitiliazeString += capitiliazeFirstLetter;
  }
  return capitiliazeString;
};

// It takes param as mins and returns hrs, mins
function convertMinsIntoTimeFormat(mins, withLabels) {
  var hrs = Math.floor(mins / 60);
  var min = mins % 60;
  if (hrs.toString().length < 2) {
    hrs = `0${hrs}`;
  }
  if (min.toString().length < 2) {
    min = `0${min}`;
  }
  if (withLabels !== undefined && withLabels === true) {
    return `${hrs}h ${min}m`;
  }
  return `${hrs}:${min}`;
}
function changeDateFormat(date) {
  var obj = format(date, "yyyy-MM-dd");
  obj = obj + "T00:00:00.000Z";
  return obj;
}

const checkSessionExpiry = () => {
  const tokenExpiryLocalStorage = window.localStorage.getItem("pmsTokenExpiry");
  if (tokenExpiryLocalStorage !== null) {
    const checkTokenExpiry =
      new Date(tokenExpiryLocalStorage).getTime() > new Date().getTime();
    return !checkTokenExpiry;
  }
  return false;
};
function Notification(data, condition) {
  if (condition === "success") {
    toast.success(data, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } else {
    toast.error(data, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
}

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
function getStartDateEndDateByFilter(dateInput, interval, period) {
  // Ensure we're working with a Date object and clone it
  const date = new Date(dateInput);

  // Get start of day to avoid time complications
  date.setHours(0, 0, 0, 0);

  // Adjust date based on period
  switch (period.toLowerCase()) {
    case "previous":
      date.setDate(date.getDate() - 7);
      break;
    case "next":
      date.setDate(date.getDate() + 7);
      break;
    case "current":
    default:
      // No adjustment needed
      break;
  }

  // Calculate the start of the week (Monday)
  const startDate = new Date(date);
  const day = date.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  startDate.setDate(date.getDate() + diffToMonday);

  // Calculate the end of the week
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + (7 * interval - 1));
  // Set to end of day
  endDate.setHours(23, 59, 59, 999);
  return { startDate, endDate };
}
function calculateDateRange(date, interval, period) {
  // Input validation
  if (!date || !interval || !period) {
    throw new Error("All parameters are required");
  }

  if (!["current", "next", "previous"].includes(period)) {
    throw new Error("Period must be one of: current, next, or previous");
  }

  if (interval < 1 || !Number.isInteger(interval)) {
    throw new Error("Interval must be a positive integer");
  }

  // Convert input date to Date object
  const inputDate = new Date(date);
  if (isNaN(inputDate.getTime())) {
    throw new Error("Invalid date format. Please use YYYY-MM-DD");
  }

  // Get the day of week (0-6, where 0 is Sunday)
  const dayOfWeek = inputDate.getDay();

  // Calculate days to subtract to get to the start of the week (Monday)
  const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

  // Create new date object for manipulation
  let startDate = new Date(inputDate);

  // Calculate the starting point based on period
  switch (period) {
    case "current":
      startDate.setDate(inputDate.getDate() - daysToMonday);
      break;
    case "next":
      startDate.setDate(inputDate.getDate() - daysToMonday + 7 * interval);
      break;
    case "previous":
      startDate.setDate(inputDate.getDate() - daysToMonday - 7 * interval);
      break;
  }

  // Calculate end date (start date + (7 * interval - 1) days)
  let endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + (7 * interval - 1));

  // Format dates to YYYY-MM-DD
  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
}
export {
  Notification,
  checkSessionExpiry,
  TimeNow,
  GMTTime,
  getDifferenceInMinutes,
  HourMinuteFormat,
  getDifferenceInTime,
  dateCheck,
  getTodayDate,
  getPreviousDate,
  getNextDate,
  monthOfYearAsString,
  dayOfWeekAsString,
  dateFormatForPopOver,
  dateFormat,
  getInitials,
  getInitialName,
  getDateInFormat,
  deleteAlertDialog,
  convertBase64,
  getDateInputFormat,
  createImageFromInitials,
  getLocalTimeFromUTCTimeWithoutSeconds,
  getRandomColor,
  getDifferenceInDays,
  convertExcelToJSON,
  convert1000ToK,
  getCountryTimeZone,
  getTimeInHoursMinutes,
  getHours,
  getLocalTimeFromUTCTime,
  getDaysInMonth,
  getRandomValueByRange,
  GetCalculatePercentage,
  GetRoundoffValue,
  EstimatedTimeToIntConvertor,
  GetLocalTimeSpan,
  IntegerToTimeString,
  TimeStringToInteger,
  IntToEstimatedTimeConvertor,
  GetDaysBetweenDates,
  getPreviewDays,
  getRandomArray,
  getElementIndex,
  GetTaskTimeProgress,
  convertTZ,
  GetProjectTaskProgress,
  getDateIn_DD_MM_YYYY_Format,
  removeHtmlTag,
  validateEmail,
  getOverdueDays,
  capitalizeFirstLetterOfEachWord,
  convertMinsIntoTimeFormat,
  changeDateFormat,
  useWindowSize,
  getZulluTimeFormatExtra,
  getStartDateEndDateByFilter,
  calculateDateRange,
  TimeStringToIntegerMins,
};
